/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddOptionKeyValueDto } from '../model/addOptionKeyValueDto';
import { MappedInfoResponseDTO } from '../model/mappedInfoResponseDTO';
import { OptionKeyValueDto } from '../model/optionKeyValueDto';
import { ProblemDetails } from '../model/problemDetails';
import { QuestionOptionResponse } from '../model/questionOptionResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class QuestionOptionService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionAddoptionPatch(body?: AddOptionKeyValueDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiQuestionOptionAddoptionPatch(body?: AddOptionKeyValueDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiQuestionOptionAddoptionPatch(body?: AddOptionKeyValueDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiQuestionOptionAddoptionPatch(body?: AddOptionKeyValueDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('patch',`${this.basePath}/api/QuestionOption/addoption`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param questionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionDeletequestionoptionDelete(questionId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiQuestionOptionDeletequestionoptionDelete(questionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiQuestionOptionDeletequestionoptionDelete(questionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiQuestionOptionDeletequestionoptionDelete(questionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (questionId !== undefined && questionId !== null) {
            queryParameters = queryParameters.set('questionId', <any>questionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/QuestionOption/deletequestionoption`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionEditoptionPatch(body?: OptionKeyValueDto, observe?: 'body', reportProgress?: boolean): Observable<QuestionOptionResponse>;
    public apiQuestionOptionEditoptionPatch(body?: OptionKeyValueDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuestionOptionResponse>>;
    public apiQuestionOptionEditoptionPatch(body?: OptionKeyValueDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuestionOptionResponse>>;
    public apiQuestionOptionEditoptionPatch(body?: OptionKeyValueDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<QuestionOptionResponse>('patch',`${this.basePath}/api/QuestionOption/editoption`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param optionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionGetMappedOptionInfoGet(optionId?: string, observe?: 'body', reportProgress?: boolean): Observable<MappedInfoResponseDTO>;
    public apiQuestionOptionGetMappedOptionInfoGet(optionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MappedInfoResponseDTO>>;
    public apiQuestionOptionGetMappedOptionInfoGet(optionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MappedInfoResponseDTO>>;
    public apiQuestionOptionGetMappedOptionInfoGet(optionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (optionId !== undefined && optionId !== null) {
            queryParameters = queryParameters.set('optionId', <any>optionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MappedInfoResponseDTO>('get',`${this.basePath}/api/QuestionOption/getMappedOptionInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param questionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionGetquestionoptionsGet(questionId?: string, observe?: 'body', reportProgress?: boolean): Observable<QuestionOptionResponse>;
    public apiQuestionOptionGetquestionoptionsGet(questionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuestionOptionResponse>>;
    public apiQuestionOptionGetquestionoptionsGet(questionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuestionOptionResponse>>;
    public apiQuestionOptionGetquestionoptionsGet(questionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (questionId !== undefined && questionId !== null) {
            queryParameters = queryParameters.set('questionId', <any>questionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QuestionOptionResponse>('get',`${this.basePath}/api/QuestionOption/getquestionoptions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param questionId 
     * @param optionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiQuestionOptionRemoveoptionPatch(questionId?: string, optionId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiQuestionOptionRemoveoptionPatch(questionId?: string, optionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiQuestionOptionRemoveoptionPatch(questionId?: string, optionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiQuestionOptionRemoveoptionPatch(questionId?: string, optionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (questionId !== undefined && questionId !== null) {
            queryParameters = queryParameters.set('questionId', <any>questionId);
        }
        if (optionId !== undefined && optionId !== null) {
            queryParameters = queryParameters.set('optionId', <any>optionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('patch',`${this.basePath}/api/QuestionOption/removeoption`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
